import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
import MatButton from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';

import ConfirmationDialog from "Routes/common/ConfirmationDialog";

import {
   allTravelForm,
   addTravelForm,
   deleteTravelform,
   fetchTravelForm,
   updateTravelForm,
   mailTravelForm 
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import AddItem from './component/addform';
import UpdateItems from './component/viewform';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

class travelform extends Component {
   
   constructor(props) {
      
      super(props);
      this.confirmationDialog = React.createRef();
         this.state = {
            viewdiv:true,
            adddiv:false,
            vdiv:false,
            edcheckoutdate:'',
            edcheckouttime:'',
            edcheckindate:'',
            edcheckintime:'',
            edleavecnt:'',
            edsepmore:0,
            edformvalue:[],   
            edacptcnt:0,
         
         };    

         this.addHandleSubmit = this.addHandleSubmit.bind(this); 
         this.onBackSection = this.onBackSection.bind(this);
         this.deleteForm = this.deleteForm.bind(this);
         this.onAddSession1 = this.onAddSession1.bind(this);
   } 

   UNSAFE_componentWillMount() {
		this.props.allTravelForm();
	}

   addHandleSubmit(event) {
      event.preventDefault();
      this.props.addTravelForm(event).then((data) => {   
           
         if(data.status==1){                
            document.getElementById("tt1form").reset();
         }
    });
      
   }
    

   onAddSession() {
		this.setState({ 
         viewdiv:false,
         vdiv:false,
         adddiv:true,
      });
	}

   onAddSession1(cttfID){
            
      this.props.fetchTravelForm(cttfID).then((data) => { 
         var resdata=data.data;
         var troption=resdata.troptions;
         var upttroption=resdata.updatetropt;
         var troptobj=[]; 
         var leavcnt='';
         var troptcnt=0;
         if(upttroption.length==0){
            {troption.map((teamval) => (   
               troptobj.push({
                  reasonfortravel: teamval.ctdy_options,
                  numberofdays: teamval.ctdy_days,
                  placetravellingto:teamval.ctdy_travel
               })
            ))}   

            leavcnt=resdata.travel[0].cttf_totaldays;
            troptcnt=troption.length;
         }else{
            {upttroption.map((teamval) => (   
               troptobj.push({
                  reasonfortravel: teamval.ctdy_options,
                  numberofdays: teamval.ctdy_days,
                  placetravellingto:teamval.ctdy_travel
               })
            ))}  
            
            leavcnt=resdata.travel[0].cttf_acdyuptdays;
            troptcnt=upttroption.length;
         } 


         if(resdata.travel[0].cttf_acdyenterby!=""){
             var checkindate= resdata.travel[0].cttf_acdycheckindate;
             var checkintime= resdata.travel[0].cttf_acdycheckintime;    
         }else{
            var checkindate= resdata.travel[0].cttf_checkindate;
            var checkintime= resdata.travel[0].cttf_checkintime; 
         }

         if(resdata.travel[0].cttf_acdycheckoutdate=="0000-00-00"){
            var checkoutdate= resdata.travel[0].cttf_checkoutdate;
            var checkouttime= resdata.travel[0].cttf_checkouttime; 
         }else{
            var checkoutdate= resdata.travel[0].cttf_acdycheckoutdate;
            var checkouttime= resdata.travel[0].cttf_acdycheckouttime; 
         }

         var acptcnt=resdata.travel[0].cttf_coachaccept+resdata.travel[0].cttf_sportsaccept+resdata.travel[0].cttf_academyaccept;

         this.setState({
            edcheckoutdate:checkoutdate,
            edcheckouttime:checkouttime,
            edcheckindate:checkindate,
            edcheckintime:checkintime,
            edleavecnt:leavcnt,
            edsepmore:troptcnt,
            edformvalue:troptobj,
            edacptcnt:acptcnt
         });

         this.setState({ 
               viewdiv:false,
               adddiv:false,
               vdiv:true,
         });

      });
   }

      
   onBackSection() {
		this.setState({ 
         adddiv:false,
         viewdiv:true,
         vdiv:false,

       });
	}  
   
   // deleteForm(cttfID){
     
   //    if(window.confirm('Are you sure to delete this record?')){          
   //       this.props.deleteTravelform(cttfID);           
   //    }
   // }

   deleteForm(data){
      this.data = data;
      this.confirmationDialog.current.openDialog();
  }

  deleteDataPermanent(popupResponse){
      
      if (popupResponse) {
          this.props.deleteTravelform(this.data);
          this.data = ""
      }
  }

    render() {
       const { match, travelformlist, loading } = this.props;
       const role=localStorage.getItem('user_role');
       const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            responsive:'standard',
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
        };

        const columns = [
            { name: "no", label: "NO" },
            { name: "name", label: "NAME" },
            { name: "chodate", label: "CHECK_OUT DATE" },
            { name: "chotime", label: "CHECK_OUT TIME" },
            { name: "chidate", label: "CHECK_IN DATE" },
            { name: "chitime", label: "CHECK_IN TIME" },
            { name: "ttotaldays", label: "TOTAL DAYS" },
            { name: "action", label: "ACTION" },
            { name: "action1", label: "ACTION1" },
          
        ];
        const tabledata=travelformlist.map((assmntval,idx) => {     

                     const ebtn=<MatButton onClick={ ()=>this.onAddSession1(assmntval.cttfID)} className="btn-info mr-10 mb-10 text-white">View</MatButton>;
                    
                    if(role==4|| role==8|| role==11 || role==39){
                     var dbtn="";
                    }else{ 
                     var dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval.cttfID)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
                    }
                if(assmntval.cttf_acdyenterby==''){
                   var totalday=assmntval.cttf_totaldays;
                }else{
                  var totalday=assmntval.cttf_acdyuptdays;
                }



                return {
                no:idx+1,
                name: assmntval.student,
                chodate: assmntval.choutdate,
                chotime:assmntval.cttf_checkouttime,
                chidate: assmntval.chindate,
                chitime:assmntval.cttf_checkintime,
                ttotaldays: totalday,
                action: ebtn,
                action1:dbtn,
                
                }
        });

 

       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>Travel Form | {AppConfig.appTitle}</title>
                <meta name="description" content="Travel" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.travelform" />} match={match} />
             
               {this.state.viewdiv && 
                  <div className="col-sm-12 col-lg-12">
                     <RctCollapsibleCard heading="List" fullBlock>
                        <MUIDataTable
                              title={<div><Button onClick={ ()=>this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add form</Button></div>}
                              data={tabledata}
                              columns={columns}
                              options={options} 
                        />   
                     </RctCollapsibleCard>
                  </div>
               }
               {this.state.adddiv && 
               <AddItem onClick={this.onBackSection} />
               }

               {this.state.vdiv && 
               <UpdateItems onClick={this.onBackSection} data={this.state} />
               }

            <ConfirmationDialog
               ref={this.confirmationDialog}
               onConfirm={(res) => this.deleteDataPermanent(res)}
               data={'travel form'}
            />
                  
          </div>
       )
    }
 }

const mapStateToProps = ({ travelform }) => {
	const { travelformlist, loading } = travelform;
	return { travelformlist, loading };
}

export default connect(mapStateToProps, {
    allTravelForm,
    addTravelForm,
    deleteTravelform,
    fetchTravelForm,
    updateTravelForm,
    mailTravelForm

   
})(travelform); 